<template>
  <v-app id="inspire">
    <router-view/>
  </v-app>
</template>

<script>
  import { http } from "./util/http.js"
  import moment from 'moment'


  export default {
    name: 'Exercises',
    props: {
      source: String,
    },
    data: () => ({
    }),
    methods: {

      logout() {
        this.$store.dispatch(AUTH_LOGOUT)
        this.$router.push('/login')
      },

      unselect() {
        this.$store.dispatch(UNSELECT);
      }

    },
    created: async function() {
      console.log(`app created`);
    },
  };
</script>

<style lang="scss">
@import "assets/scss/index";

body {
  font-family: -apple-system, system-ui, BlinkMacSystemFont;
  color: $lightPrimaryTextColor;
  font-size: 100%;
}

@media only screen and (min-width : 0px) {
  html {
    font-size: 14px !important;
  }
}

@media only screen
and (min-device-width: 375px)
and (max-device-width: 667px)
and (-webkit-min-device-pixel-ratio: 2) {
  html {
    font-size: 14px !important;
  }
}

@media only screen and (min-width : 375px) {
  html {
    font-size: 16px !important;
  }
}


</style>
